import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { HydratedEpcisSgtin } from '../types/compoundModels.ts';
import { OrderAPI } from '../api/order.ts';
import { PaginationOptions, WithPagination } from '../types/types.ts';

export const ORDER_QUERY_KEY = 'ORDER_QUERY_KEY';

const useReadManySearch = (
  params: {
    filters: OrderAPI.Request.ReadManySearch;
    paginationOptions: PaginationOptions;
  },
  options?: Partial<
    UseQueryOptions<WithPagination<OrderAPI.Response.ReadManySearch> | null>
  >
) =>
  useQuery({
    queryKey: [ORDER_QUERY_KEY, endpoints.order.read.many.search(), params],
    queryFn: () => api.order.read.many.search(params),
    ...options,
  });

const useReadAllMedsByDocumentId = (
  documentId: number | string,
  options?: Partial<UseQueryOptions<HydratedEpcisSgtin[] | null>>
) =>
  useQuery({
    queryKey: [
      ORDER_QUERY_KEY,
      endpoints.order.read.all.meds.by.documentId(),
      documentId,
    ],
    queryFn: () => api.order.read.all.meds.by.documentId(documentId),
    ...options,
  });

const orderQueryHooks = {
  useReadManySearch,
  useReadAllMedsByDocumentId,
};

export default orderQueryHooks;
